import { useEffect } from 'react';
import { load } from '@2gis/mapgl';
import type { Map as MapGL } from '@2gis/mapgl/types';
import { useMapglContext } from './MapglContext';
import { MapWrapper } from './MapWrapper';

export const MAP_CENTER = [37.783647, 44.701491];

export default function Mapgl() {
    const { setMapglContext } = useMapglContext();

    useEffect(() => {
        let map: MapGL;

        load().then((mapgl) => {
            map = new mapgl.Map('map-container', {
                center: MAP_CENTER,
                zoom: 13,
                key: '818b1c5e-837f-4b23-87fb-a29693958cb3',
            });

            map.on('click', (e) => console.log(e));

          
            const segments = [
                {
                    color: '#e84646',
                    label: 'A',
                    coords: [
                        // A -> B (геометрия до пересадки на точку B)
                        [37.783799, 44.70153],
                        [37.783603, 44.701525],
                        [37.783644, 44.70103],

                        [37.783797, 44.701034],
                        [37.783802, 44.701012],
                        [37.783834, 44.700898],
                        [37.783932, 44.700541],
                        [37.783945, 44.700496],
                        [37.783981, 44.700361],
                        [37.784181, 44.699635],
                        [37.784193, 44.699592],
                        [37.78437, 44.698941],
                        [37.784391, 44.698859],
                        [37.784422, 44.698744],
                        [37.784519, 44.698379],
                        [37.784621, 44.69799],
                        [37.784671, 44.697797],
                        [37.784742, 44.697534],
                        [37.7848, 44.697309],
                        [37.784818, 44.697243],
                        [37.784968, 44.69667],
                        [37.784977, 44.696632],
                        [37.784896, 44.696621],
                        [37.784916, 44.696551],
                        [37.784993, 44.696562],
                        [37.785, 44.696531],
                        [37.785056, 44.696284],
                        [37.785199, 44.69563],
                        [37.785214, 44.69556],
                        [37.785344, 44.694963],
                        [37.785374, 44.694828],
                        [37.785525, 44.694139],
                        [37.785546, 44.694043],
                        [37.785493, 44.694035],
                        [37.785514, 44.693965],
                        [37.785567, 44.693973],
                        [37.785576, 44.693939],
                        [37.785585, 44.693908],
                        [37.785618, 44.693815],
                        [37.785652, 44.693714],
                        [37.785715, 44.693551],
                        [37.785833, 44.693323],
                        [37.785928, 44.693179],
                        [37.786106, 44.692963],
                        [37.786136, 44.692927],
                        [37.786309, 44.692744],
                        [37.786402, 44.692654],
                        [37.786534, 44.692528],
                        [37.786695, 44.6924],
                        [37.786703, 44.692395],
                        [37.78683, 44.692301],
                        [37.78701, 44.692184],
                        [37.78711, 44.692119],
                        [37.787561, 44.691851],
                        [37.787782, 44.691717],
                        [37.787878, 44.691659],
                        [37.787982, 44.691596],
                        [37.789336, 44.690777],
                        [37.789442, 44.690714],

                        [37.789447, 44.690724],
                        [37.78943, 44.690698],

                        [37.791178, 44.689642],
                        [37.791481, 44.689458],

                        [37.791449, 44.689431],

                        [37.791985, 44.68908],
                        [37.792062, 44.689025],
                        [37.792256, 44.688791],
                        [37.792399, 44.688618],
                        [37.792436, 44.688633],
                        [37.792548, 44.688679],
                        [37.792601, 44.688619],
                        [37.792614, 44.688605],
                        [37.792604, 44.688616],
                        [37.79269, 44.688655],
                        [37.792714, 44.688627],

                        // точно ставим стык в projected B
                        [37.79265670387175, 44.68862471963877],
                    ],
                },

                {
                    color: '#e3e340',
                    label: 'B',
                    coords: [
                        // B -> C
                        [37.79265670387175, 44.68862471963877],

                        [37.792897, 44.688419],
                        [37.792954, 44.688354],
                        [37.792979, 44.688326],
                        [37.793016, 44.688284],
                        [37.793194, 44.688081],
                        [37.79336, 44.687897],
                        [37.793518, 44.687722],
                        [37.79375, 44.687509],
                        [37.794005, 44.687239],
                        [37.794244, 44.686978],
                        [37.794663, 44.686478],
                        [37.794666, 44.686474],

                        // точно ставим стык в projected C
                        [37.79461961259908, 44.68646004746368],
                    ],
                },

                {
                    color: '#43e843',
                    label: 'C',
                    coords: [
                        // C -> D
                        [37.79461961259908, 44.68646004746368],

                        [37.794666, 44.686474],
                        [37.794796, 44.686529],
                        [37.794871, 44.686561],

                        [37.794966, 44.686601],
                        [37.79506, 44.686641],

                        [37.795221, 44.686709],
                        [37.795281, 44.686734],

                        [37.795308, 44.686745],
                        [37.79547, 44.686814],

                        [37.795573, 44.686858],

                        [37.79649, 44.687245],
                        [37.796611, 44.687296],
                        [37.797533, 44.687687],

                        [37.797591, 44.687967],

                        [37.797254, 44.688371],
                        [37.797148, 44.688497],

                        // точка D (projected)
                        [37.79714881928152, 44.68849769251814],
                    ],
                },
            ];




            segments.forEach((segment, i) => {
                const zIndex = segments.length - 1 - i;
                new mapgl.Polyline(map, {
                    coordinates: segment.coords,
                    width: 10,
                    color: segment.color,
                    width2: 14,
                    color2: '#ffffff',
                    zIndex,
                });

                if (segment.label) {
                    const isFirstSegment = i === 0;
                    const isLastSegment = i === segments.length - 1;
                    const lastPointIndex = segment.coords.length - 1;

                    // Для первого сегмента - метка A в начале (стартовая точка)
                    if (isFirstSegment) {
                        new mapgl.CircleMarker(map, {
                            coordinates: segment.coords[0],
                            radius: 16,
                            color: '#0088ff',
                            strokeWidth: 2,
                            strokeColor: '#ffffff',
                            zIndex: 5,
                        });

                        new mapgl.Label(map, {
                            coordinates: segment.coords[0],
                            text: segment.label,
                            fontSize: 14,
                            color: '#ffffff',
                            zIndex: 6,
                        });
                    }

                    // Метка на конце каждого сегмента, кроме последнего
                    // (для последнего используем отдельную логику ниже)
                    if (!isLastSegment) {
                        // Определяем метку для конца сегмента
                        const nextLabel = segments[i + 1]?.label || '';

                        new mapgl.CircleMarker(map, {
                            coordinates: segment.coords[lastPointIndex],
                            radius: 16,
                            color: '#0088ff',
                            strokeWidth: 2,
                            strokeColor: '#ffffff',
                            zIndex: 4,
                        });

                        new mapgl.Label(map, {
                            coordinates: segment.coords[lastPointIndex],
                            text: nextLabel,
                            fontSize: 14,
                            color: '#ffffff',
                            zIndex: 4,
                        });
                    }

                    // Метка D на конце последнего сегмента
                    if (isLastSegment) {
                        new mapgl.CircleMarker(map, {
                            coordinates: segment.coords[lastPointIndex],
                            radius: 16,
                            color: '#0088ff',
                            strokeWidth: 2,
                            strokeColor: '#ffffff',
                            zIndex: 4,
                        });

                        new mapgl.Label(map, {
                            coordinates: segment.coords[lastPointIndex],
                            text: 'D',
                            fontSize: 14,
                            color: '#ffffff',
                            zIndex: 4,
                        });
                    }
                }
            });

            setMapglContext({
                mapglInstance: map,
                mapgl,
            });
        });

        // Destroy the map, if Map component is going to be unmounted
        return () => {
            map && map.destroy();
            setMapglContext({ mapglInstance: undefined, mapgl: undefined });
        };
    }, [setMapglContext]);

    return <MapWrapper />;
}
